"use client";

import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import {
  SECTION_LEVEL_DESCRIPTIONS,
  SECTION_LEVEL_STYLES,
  type SectionLevelName,
} from "@/lib/section-levels";

function SectionLevel({ level }: { level: SectionLevelName }) {
  return (
    <Tooltip tapToOpen>
      <TooltipTrigger asChild>
        <Badge
          variant="outline"
          data-section-level
          asChild
          className={cn(
            "text-sm font-semibold px-2.5 py-0.5 cursor-pointer select-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
            SECTION_LEVEL_STYLES[level]
          )}
        >
          <button type="button" aria-label={`${level} 레벨 설명 보기`}>
            {level}
          </button>
        </Badge>
      </TooltipTrigger>
      <TooltipContent
        side="top"
        className="max-w-xs whitespace-normal text-sm leading-relaxed"
      >
        {SECTION_LEVEL_DESCRIPTIONS[level]}
      </TooltipContent>
    </Tooltip>
  );
}

SectionLevel.displayName = "SectionLevel";
// heading id 생성 시 SectionLevel 뱃지를 식별하기 위한 정적 마커 (JCG-2144)
// reference 동일성 비교가 1순위지만, 클라이언트 렌더 경로 대비 보조 마커로 둔다.
(SectionLevel as typeof SectionLevel & { isSectionLevel: boolean }).isSectionLevel = true;
export default SectionLevel;
